export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  comicIds: string[];
}

export const categories: Category[] = [
  {
    slug: 'fantasy-adventure',
    name: '奇幻冒险',
    description: '穿越异世界、地下城探险、异能觉醒，精彩纷呈的奇幻冒险韩漫等你来发现',
    icon: 'ri-sword-line',
    comicIds: ['comic-1', 'comic-3', 'comic-5', 'comic-10']
  },
  {
    slug: 'romance-school',
    name: '恋爱校园',
    description: '甜蜜的校园恋爱、浪漫的宫廷爱情、温馨的治愈故事，感受韩漫中的浪漫时刻',
    icon: 'ri-heart-line',
    comicIds: ['comic-2', 'comic-4', 'comic-11']
  },
  {
    slug: 'thriller-mystery',
    name: '剧情悬疑',
    description: '扣人心弦的悬疑剧情、意想不到的反转、深刻的社会议题，挑战你的推理能力',
    icon: 'ri-search-eye-line',
    comicIds: ['comic-6', 'comic-7', 'comic-9']
  },
  {
    slug: 'martial-arts',
    name: '武侠古风',
    description: '刀光剑影的江湖恩怨、快意恩仇的武侠故事、古典美学的艺术呈现',
    icon: 'ri-sword-fill',
    comicIds: ['comic-8', 'comic-12']
  }
];

export const allCategorySlugs = categories.map(c => c.slug);